import React from 'react';
import { Disclosure } from '@headlessui/react';
import { FaChevronDown } from 'react-icons/fa';

const FAQ = ({ faqItems, title }) => {
  return (
    <div className="max-w-4xl mx-auto py-12">
      {title && (
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-white">{title}</h2>
      )}
      <div className="space-y-4">
        {faqItems.map((item, index) => (
          <Disclosure key={index} as="div" className="bg-purple-900/50 rounded-xl shadow-sm overflow-hidden">
            {({ open }) => (
              <>
                <Disclosure.Button 
                  className="w-full px-6 py-4 text-left text-lg font-medium text-white flex justify-between items-center"
                >
                  <span>{item.question}</span>
                  <FaChevronDown
                    className={`${
                      open ? 'transform rotate-180' : ''
                    } w-5 h-5 text-purple-300 transition-transform duration-200`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="px-6 py-4 text-gray-300 border-t border-purple-800/60">
                  <div className="whitespace-pre-wrap">{item.answer}</div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  );
};

export default FAQ; 